import { createReducer, on } from '@ngrx/store';
import {
  GetAgentRegistrationActions,
  ListAgentsByCompanyActions,
  ShippingAgentManagementState,
} from './shipping-agent-management.actions';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';

const initialRequestState = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialShippingAgentManagementState: ShippingAgentManagementState = {
  myApplications: { ...initialRequestState },
  agentRegistrationDetails: { ...initialRequestState },
};

export const shippingAgentManagementReducer = createReducer(
  initialShippingAgentManagementState,

  // List Agents By Company
  on(ListAgentsByCompanyActions.request, (state) => handleRequest(state, 'myApplications')),
  on(ListAgentsByCompanyActions.success, (state, { response }) =>
    handleSuccess(state, 'myApplications', response),
  ),
  on(ListAgentsByCompanyActions.failure, (state, { error }) =>
    handleFailure(state, 'myApplications', error),
  ),
  on(ListAgentsByCompanyActions.clearState, (state) =>
    handleClear(state, 'myApplications'),
  ),

  // Get Agent Registration Details
  on(GetAgentRegistrationActions.request, (state) =>
    handleRequest(state, 'agentRegistrationDetails'),
  ),
  on(GetAgentRegistrationActions.success, (state, { response }) =>
    handleSuccess(state, 'agentRegistrationDetails', response),
  ),
  on(GetAgentRegistrationActions.failure, (state, { error }) =>
    handleFailure(state, 'agentRegistrationDetails', error),
  ),
  on(GetAgentRegistrationActions.clearState, (state) =>
    handleClear(state, 'agentRegistrationDetails'),
  ),
);

